<template>
  <c-m-sidebar title="Field History">
    <template #content>
      <field-history-content :object-type="objectType" :object-id="objectId"></field-history-content>
    </template>
  </c-m-sidebar>
</template>

<script>
import CMSidebar from "@/components/safety_center/CMSidebar.vue";
import FieldHistoryContent from "@/components/FieldHistoryContent.vue";

export default {
  name: "FieldChangesSidebar",
  components: {CMSidebar, FieldHistoryContent},
  props: ['objectType', 'objectId']
}
</script>


